import { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import i18next from "i18next";
import { clearAgreement } from "../helpers/agreementHelper";

export function setupApiInterceptor(axiosInstance: AxiosInstance, clientType: "main" | "sdk" = "main") {
  axiosInstance.interceptors.request.use(
    async (config) => {
      if (!config.headers["Content-Type"]) {
        config.headers["Content-Type"] = "application/json";
      }

      config.headers["Accept-Language"] = i18next.language;

      const tokenKey = clientType === "sdk" ? "sdk_token" : "token";
      const token = localStorage.getItem(tokenKey);

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // if (clientType === "sdk") {
      //   config.headers["X-Client-Type"] = "sdk";
      // }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error: AxiosError) => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        handleAuthError(clientType);
      }

      return Promise.reject(error);
    }
  );
}

function handleAuthError(clientType: "main" | "sdk") {
  const isInSdkMode = window && window.location && window.location.pathname.includes("/sdk");

  if (clientType === "sdk") {
    localStorage.removeItem("sdk_token");
    localStorage.removeItem("sdk_callback");
    localStorage.removeItem("sdk_service_type");
    localStorage.removeItem("sdk_request_id");
    clearAgreement();

    if (window && window.location && !window.location.href.includes("/sdk/accessDenied")) {
      window.location.href = "/sdk/accessDenied";
    }
  } else if (isInSdkMode) {
    localStorage.removeItem("token");
    clearAgreement();
  } else {
    localStorage.removeItem("token");
    clearAgreement();

    if (window && window.location && !window.location.href.includes("/login")) {
      window.location.href = `/${i18next.language}/guest`;
    }
  }
}
